import md5 from 'crypto-js/md5';

const getPublicationId = (publicationName = '') =>
  md5(publicationName.toLowerCase()).toString();

export default getPublicationId;
